// src/constants/planLabels.js — S-304 (webapp — Rule Q twin of mobile)
//
// ⚠️ THE PLAN KEY IS AN IDENTIFIER. IT IS NOT A LABEL. NEVER PRINT IT.
//
// `'1d'` is a database value. It is `subscriptions.plan_id`, `users.plan`, and the key into
// PORTFOLIO_LIMITS / LENT_CAPITAL / SUBSCRIPTION_PRICES_*. It cannot be renamed:
//   • the Play Console SKU is `pc_premium_1day` and Google does not allow renaming a product
//   • deleting a product burns its ID forever (ECONOMY.md Rule 12)
//   • every existing subscriptions row already stores '1d'
//
// But the PRODUCT is a 3-DAY PASS. It was launched as 1 day, could not be a subscription
// (Google requires a 30-day minimum auto-renew period), so it became a one-time consumable —
// and was then extended to 3 days because 1 day felt punitive. Play Console shows "3-Day
// Pass". ECONOMY.md Part 2.2 says exactly this: "Only the display name and description change."
//
// Seven screens were doing `user.plan.toUpperCase()`, which printed "1D PLAN" to a user who
// had just bought a 3-Day Pass. Somebody who pays for three days and is then told they have a
// "1D PLAN" does not think "display bug" — they think they were cheated. That is the whole
// reason this file exists.
//
// ⚠️ '1d' MEANS OTHER THINGS ELSEWHERE. Option expiries, chart intervals and auto-square-off
//    durations all use '1d' to mean one actual day, and those are CORRECT. This helper is for
//    SUBSCRIPTION PLANS ONLY. Never apply it to a timeframe.
'use strict';

/** Short badge form — for headers, sidebars, profile chips. */
export const PLAN_SHORT = {
  free:  'FREE',
  '1d':  '3-DAY PASS',
  '1m':  '1 MONTH',
  '3m':  '3 MONTHS',
  '6m':  '6 MONTHS',
  '12m': '12 MONTHS',
};

/** Full form — for the premium screen and anywhere with room. */
export const PLAN_FULL = {
  free:  'Free',
  '1d':  'Pro · 3-Day Pass',
  '1m':  'Pro · 1 Month',
  '3m':  'Pro · 3 Months',
  '6m':  'Pro · 6 Months',
  '12m': 'Pro · 12 Months',
};

/**
 * Badge text for a plan key. Falls back to the UPPERCASED KEY for an unknown plan rather than
 * showing nothing — a new SKU should look odd, not invisible.
 */
export function planBadge(plan) {
  if (!plan || plan === 'free') return 'FREE';
  return PLAN_SHORT[plan] || String(plan).toUpperCase();
}

/** Full display name for a plan key. */
export function planName(plan) {
  if (!plan || plan === 'free') return 'Free';
  return PLAN_FULL[plan] || String(plan).toUpperCase();
}

export default { PLAN_SHORT, PLAN_FULL, planBadge, planName };
